<template>
  <apexchart
    class="custom_pie_chart"
    :width="380"
    type="pie"
    :series="[...graphData.series]"
    :options="{
      chart: {
        id: `vuechart-${graph.id}`,
        zoom: {
          enabled: false
        },
        toolbar: {
          show: true,
          export: {
            csv: {
              filename: `${graph.name}`
            },
            svg: {
              filename: `${graph.name}`
            },
            png: {
              filename: `${graph.name}`
            }
          }
        }
      },
      labels: [...graphData.labels],
      responsive: [{
        breakpoint: 480,
        options: {
          chart: {
            width: 200
          },
          legend: {
            position: 'bottom'
          }
        }
      }]
    }"
    ref="apexChart"
  ></apexchart>
</template>
<script>
import VueApexCharts from 'vue-apexcharts'

export default {
  name: 'Pie-Chart',
  props: ['graph', 'graphData', 'horizontal'],
  components: {
    apexchart: VueApexCharts
  }
}
</script>
<style>
.custom_pie_chart > div {
  width: 100% !important;
  overflow: hidden;
}
</style>